export default "__VITE_ASSET__C4c31KGJ__"